module.exports = __webpack_public_path__ + "media/images/white-check-icon-568c7c01.svg";